module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "api-request",
    class: [_vm.animate]
  }, [(_vm.state == 'loading' && !_vm.hasLoadingSlot) ? _c('div', {
    staticClass: "spinner",
    style: ({
      padding: _vm.spinnerPadding,
      zoom: _vm.spinnerScale
    })
  }, [(_vm.spinner !== 'none') ? _c(_vm.spinner, {
    tag: "component",
    attrs: {
      "color": _vm.spinnerColor
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.state == 'loading') ? _vm._t("loading") : _vm._e(), _vm._v(" "), (_vm.state == 'waiting') ? _vm._t("waiting") : _vm._e(), _vm._v(" "), (_vm.state == 'success') ? _vm._t("success") : _vm._e(), _vm._v(" "), (_vm.state == 'error') ? _vm._t("error") : _vm._e(), _vm._v(" "), (_vm.state == 'success' || _vm.state == 'error') ? _vm._t("loaded") : _vm._e(), _vm._v(" "), (_vm.state == 'success' && !_vm.hasWaitingSlot && !_vm.hasSuccessSlot) ? _vm._t("default") : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f126ef24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-api-request/src/ApiRequest.vue
// module id = 183
// module chunks = 0